<ng-container *ngIf="ticketModel">
  <div class="ticket-items">
    <div
      *ngFor="let item of ticketTableHeaderData; trackBy: trackByTicketTransactionTableHeader"
      class="ticket-header-item"
      data-qa="ticket-header-item"
      [class.currency]="item.isCurrency"
    >
      {{ item.title | translate }}
    </div>

    <hr class="dashed" />

    <ng-container
      *ngFor="let item of ticketModel.ticket.items; let i = index; trackBy: trackByItemIndex"
    >
      <ng-container *ngIf="item">
        <ng-container *ngIf="item.itemType === 1 || item.itemType === 2">
          <ng-container *ngIf="item.commodity as commodity">
            <div data-qa="product-number">{{ i + 1 }}.</div>
            <div data-qa="product-name">
              {{ item.itemType === 2 ? ('transaction.ticket.item.storno' | translate) : '' }}
              {{ commodity.name }}
            </div>
            <div class="ticket__center" data-qa="product-section-code">
              {{ commodity.sectionCode }}
            </div>
            <div class="text-right" data-qa="product-price">
              {{ item?.itemType === 1 ? commodity.price : '' }}
            </div>
            <div class="ticket__center" data-qa="product-quantity">
              {{ commodity.quantity }}
            </div>
            <div *ngIf="ticketModel" class="ticket__center" data-qa="measure-unit">
              {{ (ticketModel | ticketMeasureUnits)[i] }}
            </div>
            <div class="text-right" data-qa="barcode">{{ commodity.barcode }}</div>
            <div class="text-right" data-qa="product-sum">{{ commodity.sum }}</div>
            <div
              *ngFor="let tax of commodity.taxes; trackBy: trackByJabbaTaxIndex"
              class="ticket-items-column space-between grey-text"
              data-qa="product-tax"
            >
              <div data-qa="tax-percent">{{ tax.layout.type }} {{ tax.layout.rate * 100 }} %</div>
              <div class="text-right" data-qa="tax-sum">{{ tax.sum }}</div>
            </div>
            <span *ngIf="commodity.exciseStamp" class="ticket-items-column" data-qa="excise-stamp">
              {{ commodity.exciseStamp }}
            </span>
            <span
              *ngIf="commodity.physicalLabel"
              class="ticket-items-column"
              data-qa="physical-label"
            >
              {{ commodity.physicalLabel }}
            </span>
            <span *ngIf="commodity.productId" class="ticket-items-column" data-qa="product-id">
              {{ commodity.productId }}
            </span>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="item.itemType >= 3 && item.itemType <= 6">
          <div class="ticket-items-markup-column" data-qa="markup-name">
            <ng-container *ngIf="item.itemType === 3">
              {{ item.markup?.name }}({{ 'transaction.ticket.item.markup' | translate }})
            </ng-container>
            <ng-container *ngIf="item.itemType === 4">
              {{ item.markup?.name }}({{ 'transaction.ticket.item.storno' | translate }}
              {{ 'transaction.ticket.item.markup' | translate }})
            </ng-container>
            <ng-container *ngIf="item.itemType === 5">
              {{ item.discount?.name }}({{ 'transaction.ticket.discount' | translate }})
            </ng-container>
            <ng-container *ngIf="item.itemType === 6">
              {{ item.discount?.name }}({{ 'transaction.ticket.item.storno' | translate }}
              {{ 'transaction.ticket.discount' | translate }})
            </ng-container>
          </div>
          <div class="text-right" data-qa="markup-sum">
            <ng-container *ngIf="item.itemType === 3 || item.itemType === 4"
              >{{ item.markup?.sum }}
            </ng-container>
            <ng-container *ngIf="item.itemType === 5 || item.itemType === 6"
              >{{ item.discount?.sum }}
            </ng-container>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>

  <hr class="dashed" />

  <div class="layout-2-equals-column bold-text line-space" data-qa-block="total">
    <span data-qa="total-sum">{{ 'transaction.ticket.total' | translate }}</span>
    <span *ngIf="ticketModel.ticket as ticket" class="text-right" data-qa="total-sum">{{
      ticket.totalSum
    }}</span>
  </div>

  <div
    *ngFor="let payment of ticketModel.ticket.payments; trackBy: trackByPaymentIndex"
    class="layout-2-equals-column line-space"
  >
    <span [attr.data-qa]="'payment-type-title-' + payment.paymentType">{{
      payment | paymentType | translate
    }}</span>
    <span class="text-right" [attr.data-qa]="'payment-type-sum-' + payment.paymentType">{{
      payment.sum
    }}</span>
  </div>

  <div class="layout-2-equals-column line-space" *ngIf="ticketModel.ticket.changeSum">
    <div data-qa="change-sum-title">{{ 'transaction.ticket.change' | translate }}</div>
    <div class="text-right" data-qa="change-sum">{{ ticketModel.ticket.changeSum }}</div>
  </div>

  <div class="layout-2-equals-column line-space" *ngIf="ticketModel.totalDiscount">
    <div data-qa="change-total-discount">{{ 'transaction.ticket.discount' | translate }}</div>
    <div class="text-right" data-qa="total-discount">{{ ticketModel.totalDiscount }}</div>
  </div>

  <div class="layout-2-equals-column line-space" *ngIf="ticketModel.totalMarkup">
    <div data-qa="total-markup-title">{{ 'transaction.ticket.markup' | translate }}</div>
    <div class="text-right" data-qa="total-markup">{{ ticketModel.totalMarkup }}</div>
  </div>

  <div *ngIf="ticketModel.taxes.length" data-qa-block="taxes-sum">
    <span data-qa="including-taxes-title">{{
      'transaction.ticket.including-taxes' | translate
    }}</span>
    <div
      *ngFor="let tax of ticketModel.taxes; trackBy: trackByTaxIndex"
      class="layout-2-equals-column"
      data-qa="tax"
    >
      <div data-qa="tax-main-info">{{ tax | taxPercentage }}</div>
      <div data-qa="tax-sum" class="text-right">{{ tax.sum }}</div>
    </div>
  </div>

  <hr class="dashed" />

  <ng-container *ngIf="ticketModel.ticket as ticket">
    <div class="ticket-common-information">
      <ng-container *ngFor="let item of ticketCommonInformation">
        <div *ngIf="ticket[item.property] as value" [attr.data-qa]="'customer-' + item.name">
          {{ item.title | translate }}: {{ value }}
        </div>
      </ng-container>
      <div data-qa="customer-fiscal-id">
        {{ 'transaction.ticket.fiscal' | translate }}:
        <span>{{ ticket.offlineFiscalId ?? ticket.fiscalId }}</span>
      </div>
    </div>

    <hr class="dashed" />

    <div data-qa-block="ticket-ad-info">
      <div *ngFor="let adInfo of ticket.ticketAdInfo; trackBy: trackByTicketAdInfoIndex">
        <em *ngIf="adInfo.text as text" data-qa="ticket-ad-info-text">{{ text }}</em>
      </div>
    </div>
  </ng-container>
</ng-container>
